import { config } from "./config";

export const FEATURE_CONFIG = {
    enableListingImages: config.VITE_ENABLE_LISTING_IMAGES || "1",
    enableUpsellTypes: config.VITE_ENABLE_UPSELL_TYPES || "0",
};
